export default __webpack_public_path__ + "5cfa218a5a656bff8ac49c7e1fc153d3.jpg";